
import { func } from '../../main';
import axios from '../../api'
import router from '../../router';

import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

const state = {
    UserFullName: '',
    IsUserAuthenticated: false,
    loading: false,
    Loading: false,
    userStatus: null,
    isAdmin: false,
    isFreeRegist: false,
    hasCom: false,
    NotificationCount: 0,
    llegalPage: ["WorkGroupList", "WorkGroupEdit", "WorkGroupCreate", "OrgUnitReport", "OrgUnitReportDetails", "TaskWork", "CreateReminder", "TaskList", "CloseTask", "TaskTypeList", "InviteUser", "InviteUserPage", "NotificationList", "CreateTask", "EidtTask", "Task", "NoticeMassageUser", "NoticeMassageUserList", "VacationCreate", "VacationEdit", "VacationList", "ReminderList", "CreateUserPresence","EditUserPresence"],
    AuthToken: "",
    ApplicationMenuObjList: [],
    LocalUserListForMention: [],
    UserStatuse: []
};


const getters = {
    GetAuthToken(state: any) {
        return state.AuthToken;
    },
    GetUserFullName(state: any) {
        return state.UserFullName;
    },

    IsUserAuthenticated(state: any) {
        return state.IsUserAuthenticated;
    },
    GetLoading(state: any) {
        return state.loading;
    },
    GetUserStatus(state: any) {
        return state.userStatus;
    },
    GetIsAdmin(state: any) {
        return state.isAdmin;
    },
    GetHasCom(state: any) {
        return state.hasCom;
    },
    GetIsFreeRegist(state: any) {
        return state.isFreeRegist;
    },
    GetNotificationCount(state: any) {
        return state.NotificationCount;
    },
    GetLocalUserListForMention(state: any) {
        return state.LocalUserListForMention;
    },
    GetApplicationMenuObjList: (state: any) => (fieldName: string) => {
        if (!state.ApplicationMenuObjList || state.ApplicationMenuObjList == null) {
            return null;
        }
        const item = state.ApplicationMenuObjList.find(x => x.objName === fieldName);
        if (item != null) {
            return item.lblTitle
        }
        else {
            return null;
        }

    },
    GetApplicationMenuObjIsEnabled: (state: any) => (fieldName: string) => {
        const item = state.ApplicationMenuObjList.find(x => x.objName === fieldName);
        if (item != null) {
            return item.enabled;
        }
        else {
            return true;
        }

    }
    ,
    GetUserStatuse(state) {
        return state.UserStatuse;
    }

};

const mutations = {

    SetUserFullName(state: any, userFullName: any) {
        state.UserFullName = userFullName;
    },
    SetAuthToken(state: any, val: any) {
        state.AuthToken = val;
    },
    SetNotificationCount(state: any, c: any) {
        state.NotificationCount = c;
    },
    SetHasCom(state: any, c: any) {
        state.hasCom = c;
    },
    SetUserAuthenticated(state: any, isAuth: any) {
        state.IsUserAuthenticated = isAuth;
    },
    SetLoading(state: any, val: any) {
        state.loading = val;
    },
    SetUserStatus(state: any, val: any) {
        state.userStatus = val;
    },
    SetIsAdmin(state: any, val: any) {
        state.isAdmin = val;
    },
    SetIsFreeRegist(state: any, val: any) {
        state.isFreeRegist = val;
    },
    DeleteAuthCookie() {
        cookies.remove("eInfo1");
        cookies.remove("eInfo2");
    },
    SetApplicationMenuObjList(state: any, val: any) {
        state.ApplicationMenuObjList = val;
    },
    SetLocalUserListForMention(state: any, val: any) {
        state.LocalUserListForMention = val;
    },
    SetUserStatuse(state, val) {
        state.UserStatuse = val;
    }
};

const actions = {

    LoginUser(context: any, loginData: any) {
        context.commit("SetLoading", true);

        axios.post('Account/LoginUser', loginData).then(function (response: any) {
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map(function (a: any) {
                    return a.errorMessage;
                });
                func.showErrorMessage(res.join('\n'));

                if (response.data.userStatus != undefined && response.data.userStatus != null) {
                    context.commit("SetUserStatuse", response.data.userStatus);
                }

            }
            else {
                cookies.set("eInfo1", response.data.user.token.substring(0, 4000), "60d");
                cookies.set("eInfo2", response.data.user.token.substring(4000, response.data.user.token.length), "60d");
                //func.setCookie("eInfo", response.data.user.token, 30);
                context.commit("SetAuthToken", response.data.user.token);
                context.commit("SetUserFullName", response.data.user.fullName);
                context.commit("SetUserAuthenticated", true);
                window.location.href = "/";
            }
            context.commit("SetLoading", false);
        }, function (data: any) {
            console.log(data);
        });
    },

    ChangePass(context: any, loginData: any) {
        context.commit("SetLoading", true);

        axios.post('Account/ChangePass', loginData).then(function (response: any) {
            console.log(response);
            if (response.data == "0") {
                func.showSuccessMessage("با موفقیت ثبت شد.");
                router.push('/');
            }
            else {
                const res = response.data.errors.map(function (a: any) {
                    return a.errorMessage;
                });
                func.showErrorMessage(res.join('\n'));
            }
            context.commit("SetLoading", false);
        }, function (data: any) {
            console.log(data);
        });
    },
    GetLocalUserListForMention(context: any, filter: any) {
        axios.get("Task/GetLocalUserListForMention", {
            params: {
                text: filter.text,
                workGroupId: filter.workGroupId
            }
        })
            .then(data => {
                context.commit("SetLocalUserListForMention", data.data);
            });
    },
    GetHasCom(context: any, filter: any) {
        axios.get("Task/GetHasCom", {
        })
            .then(data => {
                context.commit("SetHasCom", data.data);
            });
    },
    CheckForLogin(context: any) {
        axios.get('Account/GetUserName').then(function (response: any) {

            if (response.data.toString() !== "-1") {
                console.log(response.data);
                context.commit("SetUserFullName", response.data);
                context.commit("SetUserAuthenticated", true);
            }
            else {
                console.log("notAuth");
                context.commit("SetUserFullName", '');
                context.commit("SetUserAuthenticated", false);
                router.push('/login');
            }
        }, function (data: any) {
            console.log(data);
        });
    },
    GetNotificationCountFromServer(context: any) {
        axios.get('Account/GetNotificationCount').then(function (response: any) {
            console.log(response);
            context.commit("SetNotificationCount", response.data);

        }, function (data: any) {
            console.log(data);
        });
    },
    GetApplicationMenuObjFromServer(context: any) {
        axios.get('Account/GetApplicationMenuObjList').then(function (response: any) {
            console.log(response);
            context.commit("SetApplicationMenuObjList", response.data);

        }, function (data: any) {
            console.log(data);
        });
    },
    SendRegistCode() {
        axios.get('Account/ResendSms').then(function (response: any) {
            console.log(response);
            if (response.data !== "-1") {
                console.log(response.data);
            }
            else {
                router.push('/login');
            }
        }, function (data: any) {
            console.log(data);
        });
    },
    AddUserDevice(context: any, item: any) {
        axios.post('Account/AddUserDevice?fcmToken=' + item.fcmToken, item.fcmToken).then(function (response: any) {
            console.log("added device:" + response.data);
            cookies.set("fcmT", item.fcmToken, "60d");

        }, function (data: any) {
            console.log(data);
        });
    },
    GetUserTaskStatusFromServer(context: any) {
        axios.get("Task/TaskOnline_GetUserActiveStatus", {

        })
            .then(function (data: any) {
                context.commit("SetUserStatus", data.data);
                context.commit("SetIsAdmin", data.data.adminOrUser);
                context.commit("SetIsFreeRegist", data.data.freeRegist);
                if (data.disabled == true) {
                    router.push("/Expired/2");
                }
                else {

                    const url = window.location.pathname.split("/");
                    if (url.length > 1) {
                        const page = url[1];
                        if (state.llegalPage.includes(page) && data.data.expired == true && data.data.freeRegist != true) {
                            if (data.data.adminOrUser == false) {
                                router.push("/Expired/0");
                            }
                            else {
                                router.push("/Expired/1");
                            }
                        }
                    } else {
                        if (data.data.expired == true && data.data.freeRegist != true) {
                            if (data.data.adminOrUser == false) {
                                router.push("/Expired/0");
                            }
                            else {
                                router.push("/Expired/1");
                            }
                        }
                    }
                }

            });
    },
    SignOutUser(context: any) {
        axios.get('Account/LogOut').then(function (response: any) {
            console.log(response);
            if (response.status === 200) {

                const fcmToken = cookies.get('fcmT');

                context.dispatch("DisableUserDevice", { fcmToken: fcmToken });



            }
        });
    },
    DisableUserDevice(context: any, item: any): void {
        console.log("fcmT content:" + item.fcmToken);
        axios.get('Account/DisableUserDevice?fcmToken=' + item.fcmToken).then(function (response: any) {
            console.log(response);
            cookies.remove("fcmT");
            window.location.href = "/login";
            context.commit("SetUserFullName", '');
            context.commit("SetUserAuthenticated", false);
            context.commit("DeleteAuthCookie");
        }, function (reason: any) {
            console.log(reason);
            context.commit("SetUserFullName", '');
            context.commit("SetUserAuthenticated", false);
            context.commit("DeleteAuthCookie");
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
